import React, { useState, useEffect } from 'react';
import apiClient from '../api/apiClient';
import { useAuth } from '../context/AuthContext';
import { ROLES } from '../utils/roles';
import TerminSelector from '../components/TerminSelector';
import { downloadCSV } from '../utils/csvExport';
import './StaffPage.css';

const IncomingAllocationPage = () => {
  const { user } = useAuth();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentTerminId, setCurrentTerminId] = useState(null);

  useEffect(() => {
    if (user && currentTerminId) {
      fetchData();
    }
  }, [user, currentTerminId]);

  const fetchData = async () => {
    setLoading(true);
    try {
      let url = `/api/allocation/incoming?termin_id=${currentTerminId}`;
      if (user.role === ROLES.SC_ADMIN && user.scId) {
         url += `&scId=${user.scId}`;
      }
      const res = await apiClient.get(url);
      setList(res.data);
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  const handleDownload = () => {
    if (list.length === 0) return alert('Ingen data at hente');

    // Flere felter her pga. kontaktinfo
    const fields = [
      { label: 'Fornavn', value: 'fornavn' },
      { label: 'Efternavn', value: 'efternavn' },
      { label: 'Email', value: 'email' },
      { label: 'Telefon', value: 'telefon' },
      { label: 'Adresse', value: 'adresse' },
      { label: 'Postnr', value: 'postnummer' },
      { label: 'By', value: 'forstad' },
      { label: 'Kommer fra', value: 'origin_sc_name' },
      { label: 'Prøve', value: 'prøve' },
      { label: 'Type', value: 'type' },
      { label: 'Antal Hold', value: 'hold_count' },
      { label: 'Antal Kursister', value: 'elev_count' }
    ];

    const filename = `Indkommende_Censorer_${new Date().toISOString().slice(0,10)}`;
    downloadCSV(list, fields, filename);
  };

  return (
    <div>
      <div className="table-card" style={{
        marginBottom: '20px', background: 'transparent', boxShadow: 'none', padding: 0,
        display: 'flex', justifyContent: 'space-between', alignItems: 'center'
      }}>
         <TerminSelector onTerminChange={(id) => setCurrentTerminId(id)} />
         
         <button 
            onClick={handleDownload}
            style={{
              backgroundColor: '#28a745', color: 'white', border: 'none', 
              padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold',
              display: 'flex', alignItems: 'center', gap: '8px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
            }}
         >
           Download CSV
         </button>
      </div>

      <div className="table-card">
        {loading ? <p>Henter data...</p> : (
          <table className="censor-table">
            <thead>
              <tr>
                <th>Censor</th>
                <th>Kontaktinfo</th>
                <th>Kommer fra</th>
                <th>Opgave</th>
                <th>Antal opgaver</th>
              </tr>
            </thead>
            <tbody>
              {list.map((row, idx) => (
                <tr key={idx}>
                  <td>
                    <strong>{row.fornavn} {row.efternavn}</strong>
                    <div style={{fontSize:'0.8rem', color:'#888'}}>
                        {row.adresse}, {row.postnummer} {row.forstad}
                    </div>
                  </td>
                  <td>
                    <div>{row.email}</div>
                    <div style={{fontSize:'0.8rem', color:'#666'}}>{row.telefon}</div>
                  </td>
                  <td><span style={{color: '#003366', fontWeight:'bold'}}>{row.origin_sc_name}</span></td>
                  <td>
                    {row.prøve} <br/>
                    <span className="role-badge censor-badge" style={{fontSize:'0.7rem'}}>{row.type}</span>
                  </td>
                  <td style={{fontWeight: 'bold', fontSize: '1.1rem'}}>
                    {row.elev_count || 0}
                  </td>
                </tr>
              ))}
              {list.length === 0 && !loading && <tr><td colSpan="5" style={{textAlign:'center', padding:'20px'}}>Ingen indgående censorer tildelt for denne termin.</td></tr>}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default IncomingAllocationPage;